import { render, staticRenderFns } from "./f5.vue?vue&type=template&id=713af9f6&scoped=true&"
import script from "./f5.vue?vue&type=script&lang=js&"
export * from "./f5.vue?vue&type=script&lang=js&"
import style0 from "./f5.vue?vue&type=style&index=0&id=713af9f6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "713af9f6",
  null
  
)

component.options.__file = "f5.vue"
export default component.exports